import * as React from "react";
import Svg, { G, Path, Defs, ClipPath, Rect } from "react-native-svg";

function SVGComponent(props) {
  return (
    <Svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_9346_5178)">
        <Path
          d="M19.6972 16.3574C19.3164 16.0741 18.7781 16.1532 18.4948 16.534C18.339 16.7434 18.1722 16.9488 17.9992 17.1446C17.6849 17.5001 17.7183 18.0432 18.0738 18.3576C18.2374 18.5022 18.4404 18.5731 18.6427 18.5731C18.8804 18.5731 19.1171 18.475 19.2869 18.2829C19.4918 18.0512 19.6893 17.8079 19.8738 17.5598C20.1571 17.1791 20.078 16.6407 19.6972 16.3574Z"
          fill="#2195F2"
        />
        <Path
          d="M21.1342 12.3275C20.6707 12.2265 20.2126 12.5206 20.1117 12.9844C20.0561 13.2395 19.989 13.495 19.9121 13.7441C19.7719 14.1976 20.026 14.6787 20.4794 14.8189C20.5639 14.845 20.6494 14.8574 20.7334 14.8574C21.1004 14.8574 21.4402 14.6204 21.5542 14.2514C21.6456 13.9559 21.7252 13.6526 21.7911 13.3499C21.8921 12.8862 21.5979 12.4284 21.1342 12.3275Z"
          fill="#2195F2"
        />
        <Path
          d="M15.5605 19.1101C15.3324 19.2375 15.0961 19.3565 14.8584 19.4639C14.4259 19.6592 14.2336 20.1683 14.4289 20.6008C14.5724 20.9186 14.8852 21.1067 15.2126 21.1067C15.3309 21.1067 15.4511 21.0822 15.5658 21.0303C15.8478 20.903 16.1279 20.7618 16.3984 20.6108C16.8129 20.3794 16.9612 19.8559 16.7298 19.4415C16.4985 19.0272 15.975 18.8788 15.5605 19.1101Z"
          fill="#2195F2"
        />
        <Path
          d="M10.1408 4.125V10.644L6.98948 13.7953C6.6539 14.1309 6.6539 14.675 6.98948 15.0106C7.15732 15.1785 7.37719 15.2623 7.59719 15.2623C7.8171 15.2623 8.03706 15.1784 8.2049 15.0106L11.6079 11.6077C11.769 11.4465 11.8595 11.2279 11.8595 11V4.125C11.8595 3.65037 11.4748 3.26562 11.0001 3.26562C10.5255 3.26562 10.1408 3.65037 10.1408 4.125Z"
          fill="#2195F2"
        />
        <Path
          d="M21.1406 1.84766C20.666 1.84766 20.2812 2.2324 20.2812 2.70703V5.09334C18.281 1.95628 14.7877 0 11 0C8.0618 0 5.29947 1.14421 3.2218 3.2218C1.14421 5.29947 0 8.0618 0 11C0 13.9382 1.14421 16.7005 3.2218 18.7782C5.29947 20.8558 8.0618 22 11 22C11.0073 22 11.0143 21.9991 11.0215 21.9989C11.0287 21.9991 11.0357 22 11.043 22C11.3527 22 11.6655 21.9869 11.9727 21.9612C12.4456 21.9216 12.797 21.5061 12.7574 21.0332C12.7177 20.5602 12.3028 20.2087 11.8293 20.2485C11.5696 20.2702 11.305 20.2812 11.043 20.2812C11.0357 20.2812 11.0287 20.2822 11.0215 20.2823C11.0143 20.2822 11.0073 20.2812 11 20.2812C5.88229 20.2812 1.71875 16.1177 1.71875 11C1.71875 5.88229 5.88229 1.71875 11 1.71875C14.2982 1.71875 17.3317 3.47673 18.9894 6.27344H16.6265C16.1518 6.27344 15.7671 6.65818 15.7671 7.13281C15.7671 7.60745 16.1518 7.99219 16.6265 7.99219H19.25C19.7734 7.99219 20.263 7.84511 20.6799 7.5903C20.7067 7.575 20.7325 7.55855 20.757 7.5408C21.505 7.04877 22 6.20241 22 5.24219V2.70703C22 2.2324 21.6153 1.84766 21.1406 1.84766Z"
          fill="#2195F2"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_9346_5178">
          <Rect width={22} height={22} fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
export default SVGComponent;
